
var InPlayer = require('@inplayer-org/inplayer.js')
InPlayer.setConfig('development');





export default InPlayer;